<template>
  <a-select
    v-if="visible"
    style="width: 100%"
    :value="currentValue"
    @change="handleChange">
    <a-select-option value="">本店</a-select-option>
    <a-select-option v-for="item in stores" :key="item.tenantId" :value="String(item.tenantId)">{{ item.name }}</a-select-option>
  </a-select>
</template>

<script>
import Vue from 'vue'
import store from '@/store'
import { getAction } from '@/api/manage'
import { USER_INFO } from '@/store/mutation-types'

// 模块级会话缓存：同一登录租户内多个报表页共享一次用户信息查询
let sessionCacheTenantId = null
let sessionCache = null

/**
 * 门店查询选项（报表跨租户查询）：
 * 仅总店租户、本页数据项域已授权且存在子租户门店时渲染；
 * 选"本店"或未选择不携带目标头，选择门店后全局请求携带 X-Target-Tenant（由 request.js 拦截器附加）。
 */
export default {
  name: 'StoreTenantSelect',
  props: {
    // 报表所属数据项域编码：stock 进销存与库存 / sale 销售与利润 / capital 资金与往来
    domain: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      visible: false,
      stores: [],
      currentValue: ''
    }
  },
  created () {
    this.init()
  },
  methods: {
    getLoginTenantId () {
      const userInfo = Vue.ls.get(USER_INFO)
      if (userInfo && userInfo.tenantId !== undefined && userInfo.tenantId !== null) {
        return String(userInfo.tenantId)
      }
      return null
    },
    init () {
      const tenantId = this.getLoginTenantId()
      // 账号切换防护：登录租户变化时清空残留目标门店与缓存
      if (store.state.storeTenant.loginTenantId !== null && store.state.storeTenant.loginTenantId !== tenantId) {
        store.commit('CLEAR_STORE_TENANT')
      }
      if (sessionCacheTenantId !== tenantId) {
        sessionCacheTenantId = tenantId
        sessionCache = null
      }
      const fetch = sessionCache ? Promise.resolve(sessionCache) : getAction('/user/getUserSession').then((res) => {
        if (res && res.code === 200 && res.data) {
          sessionCache = {
            headquarters: !!res.data.headquarters,
            allowQueryItems: res.data.allowQueryItems || [],
            storeTenants: res.data.storeTenants || []
          }
        } else {
          sessionCache = { headquarters: false, allowQueryItems: [], storeTenants: [] }
        }
        return sessionCache
      }).catch(() => {
        sessionCache = { headquarters: false, allowQueryItems: [], storeTenants: [] }
        return sessionCache
      })
      fetch.then((info) => {
        const authorized = info.allowQueryItems.indexOf(this.domain) > -1
        this.stores = info.storeTenants
        this.visible = info.headquarters && authorized && this.stores.length > 0
        if (this.visible) {
          this.currentValue = store.state.storeTenant.targetTenant || ''
        }
      })
    },
    handleChange (value) {
      store.commit('SET_STORE_TENANT', { loginTenantId: this.getLoginTenantId(), targetTenant: value || '' })
      this.currentValue = value || ''
      this.$emit('change', value || '')
    }
  }
}
</script>
